// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header[data-v-1c175950]{text-align:center}.logo[data-v-1c175950]{margin:0 auto}.link__img[data-v-1c175950]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
